<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Categories"><categories></categories></mat-tab>
  <mat-tab label="Sub Categories"><sub-categories></sub-categories></mat-tab>
</mat-tab-group>
